<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Marke erstellen') }}</h1>
        </div>

        <div class="">
            <form @submit.prevent="form.post(route('admin.brands.store'))">
                <form-fields :form="form" :countries="countries" />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'countries',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    name: null,
                    slug: null,
                    meta_title: null,
                    meta_description: null,
                    description: null,
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>